module.exports = __webpack_public_path__ + "static/work62-5b7d411b76ca9b9d377ed0625f59ba0a.jpg";